import { RiskFactor } from "~/pages/space/security/components/RiskFactors/RiskFactorsIcons";

// return only the number of riskfactors that have a negative effect
// each risk factor should only be counted once
export const affectedRiskFactorsCount = (
  riskFactors: RiskFactor[] | null,
): number => {
  return riskFactors?.filter((rf) => (rf?.affected || 0) > 0)?.length || 0;
};
